module.exports = __webpack_public_path__ + "media/images/icons/registered-14fa5bae1fb4d8a94b2bc4b7121498a5.svg";